<ng-container *transloco="let t; read: TRANSLATION_SCOPE">
  <ng-container *ngIf="authFacade.showSuccessMessage$ | async; else showSignUpForm">
    <h3 class="text-center mb-4">
      {{ t('success.header') }}
    </h3>

    <p class="f-size-sm my-4">
      {{ t('success.message', { email: form.controls.emailAddress.value }) }}
    </p>

    <rx-button buttonClass="primary" [routerLink]="addAbsolutePathPrefix(authRoutes.Login)" [flexible]="true">
      {{ t('success.button') }}
    </rx-button>

    <hr class="border-top my-3" />

    <p
      class="f-size-xs mb-2"
      *ngIf="authConfig.loginContactName && authConfig.loginContactEmail"
      [innerHTML]="
        t('success.problem', {
          name: authConfig.loginContactName,
          email: authConfig.loginContactEmail
        })
      "
    ></p>
  </ng-container>
  <ng-template #showSignUpForm>
    <h3 class="text-center mb-4">{{ t('header') }}</h3>

    <rx-alert *ngIf="authFacade.error$ | async as error" type="danger" [message]="error"></rx-alert>

    <form [formGroup]="form" (ngSubmit)="onSubmit(authConfig)" novalidate>
      <!-- name -->
      <div class="form-group">
        <rx-input formControlName="name" [label]="t('label.name')" [placeholder]="t('label.namePlaceholder')" type="text">
          <div rx-error>
            <div *ngIf="isFieldInvalid(form, 'name', 'required')">
              {{ t('error.nameMissing') }}
            </div>
            <div *ngIf="isFieldInvalid(form, 'name', 'pattern')">
              {{ t('error.nameInvalid') }}
            </div>
          </div>
        </rx-input>
      </div>

      <!-- phone number -->
      <div class="form-group">
        <rx-input formControlName="phoneNumber" [label]="t('label.phone')" type="text">
          <div rx-error>
            <div *ngIf="isFieldInvalid(form, 'phoneNumber', 'required')">
              {{ t('error.phoneMissing') }}
            </div>
            <div *ngIf="isFieldInvalid(form, 'phoneNumber', 'pattern')">
              {{ t('error.phoneInvalid') }}
            </div>
          </div>
        </rx-input>
      </div>

      <!-- email address -->
      <div class="form-group">
        <rx-input
          formControlName="emailAddress"
          type="email"
          [label]="t('form.label.email')"
          [placeholder]="t('form.label.emailPlaceholder')"
        >
          <div rx-error>
            <div *ngIf="isFieldInvalid(form, 'emailAddress', 'required')">
              {{ t('error.emailMissing') }}
            </div>
            <div *ngIf="isFieldInvalid(form, 'emailAddress', 'email')">
              {{ t('error.emailInvalid') }}
            </div>
            <div *ngIf="isFieldInvalid(form, 'emailAddress', 'validDomain')">
              {{ t('error.emailDomain', { email: form.controls.emailAddress.value }) }}
            </div>
          </div>
        </rx-input>
      </div>

      <rx-password-match-form
        [parentForm]="form"
        [passwordLabel]="t('label.password')"
        [passwordConfirmLabel]="t('label.passwordConfirm')"
        [passwordMissing]="t('error.passwordMissing')"
        [passwordNotEqual]="t('error.passwordNotEqual')"
        [passwordPattern]="t('error.passwordPattern')"
      ></rx-password-match-form>
      <rx-applications-password-policy />
      <rx-button buttonClass="primary" type="submit" [flexible]="true" [disabled]="authFacade.isLoading$ | async">
        <span *ngIf="(authFacade.isLoading$ | async) === false; else isLoading"> {{ t('button.active') }}</span>
        <ng-template #isLoading>
          {{ t('button.loading') }}
        </ng-template>
      </rx-button>
    </form>

    <hr class="border-top my-3" />

    <p class="f-size-xs mb-2">
      {{ t('loginPrefix') }}
      <a class="f-size-xs" [routerLink]="addAbsolutePathPrefix(authRoutes.Login)">
        {{ t('loginLink') }}
      </a>
    </p>
  </ng-template>
</ng-container>
